module.exports = __webpack_public_path__ + "static/img/autogood1.a230d9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/autogood1.png
// module id = 8BFg
// module chunks = 1